<template>
<div class="login-view">
  <Spinner ref="spinner" :block="true"/>
  <div class="container-fluid">
    <div class="row mt-5">
      <div class="col-12 col-sm-12 col-md-6 col-xl-4 col-lg-4 mx-auto">
        <div class="text-center pb-5" style="margin-top: 40%;">
          <img src="img/logo.png" alt="Paggcerto" title="Paggcerto"/>
        </div>
        <form @submit.prevent="signin">
          <div class="form-group" :class="{ 'has-error': $v.user.email.$error }">
            <label for="input-email">Email:</label>
            <input type="email" class="form-control" id="input-email" aria-describedby="emailHelp"
              v-model.trim="user.email" @input="$v.user.email.$touch()" placeholder="Digite seu e-mail" maxlength="120">
            <small v-if="!$v.user.email.email" class="text-danger">E-mail inválido</small>
            <small v-if="!$v.user.email.required && $v.user.email.$error" class="text-danger">Campo obrigatório</small>
            <small v-if="!$v.user.email.maxLength && $v.user.email.$error" class="text-danger">Campo aceita até 120 caracteres</small>
          </div>
          <div class="form-group" :class="{ 'has-error': $v.user.password.$error }">
            <label for="input-senha">Senha:</label>
            <input type="password" :class="{ 'has-error': $v.user.password.$error }" class="form-control" id="input-senha"
              v-model.trim="user.password" @input="$v.user.password.$touch()" placeholder="Digite sua senha" minlength="8" maxlength="120">
            <small v-if="!$v.user.password.required && $v.user.password.$error" class="text-danger">Campo obrigatório</small>
            <small v-if="!$v.user.password.minLength && $v.user.password.$error" class="text-danger">Campo aceita no mínimo 8 caracteres</small>
            <small v-if="!$v.user.password.maxLength && $v.user.password.$error" class="text-danger">Campo aceita até 120 caracteres</small>
          </div>
          <div >
            <button :disabled="$v.$invalid" type="submit" class="btn btn-primary btn-block mt-4">Logar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import AccountApi from './../../services/AccountApi'
import router from '../../router'
export default {
  name: 'Login',
  data: () => {
    return {
      user: {
        email: '',
        password: ''
      }
    }
  },
  mounted: () => {
    if (localStorage.getItem('stateAntiFraud') != null) { router.push({ name: 'home', params: {} }) }
  },
  methods: {
    async signin () {
      this.$refs.spinner.show('Autenticando...')

      const api = new AccountApi()

      try {
        let auth = await api.signin(this.user)

        localStorage.setItem('stateAntiFraud', JSON.stringify(auth))

        auth.whoAmI = await api.whoAmI()

        localStorage.removeItem('stateAntiFraud')
        localStorage.setItem('stateAntiFraud', JSON.stringify(auth))

        router.push({ name: 'home', params: {} })
      } catch (e) {
        const toast = this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 5000
        })

        toast({
          type: 'error',
          title: 'Usuário ou senha inválido'
        })
      }

      this.$refs.spinner.hide()
    }
  },
  validations: {
    user: {
      email: {
        required,
        email,
        maxLength: maxLength(120)
      },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(120)
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
